'use client';

import PRODUCTPAGE from '@/views/product/chatbot';

export default PRODUCTPAGE;
